@if (currentLead) {
  <app-lead-metadata-details-v2
    [lead]="currentLead"
    [originalLead]="originalLead || undefined"
  />
} @else {
  <div class="text-muted" i18n>Pas de metadata disponible pour ce snapshot</div>
}
